import { render, staticRenderFns } from "./WarehouseOrders.vue?vue&type=template&id=684b9012"
import script from "./WarehouseOrders.vue?vue&type=script&lang=js"
export * from "./WarehouseOrders.vue?vue&type=script&lang=js"
import style0 from "./WarehouseOrders.vue?vue&type=style&index=0&id=684b9012&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports